import React, { forwardRef } from 'react';

const icon = (children) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{children}</svg>
);
const ICONS = {
  hear: icon(<><path d="M4 9.5v5h3.5L12 18.5v-13L7.5 9.5H4z" /><path d="M15.5 9a4 4 0 0 1 0 6" /><path d="M18 6.5a7.5 7.5 0 0 1 0 11" /></>),
  stop: icon(<rect x="7" y="7" width="10" height="10" rx="2" fill="currentColor" stroke="none" />),
  mic: icon(<><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5.5 11a6.5 6.5 0 0 0 13 0" /><path d="M12 17.5V21" /></>),
  clear: icon(<><path d="M9 5h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-6-7 6-7z" /><path d="M12 9.5l5 5M17 9.5l-5 5" /></>),
  exchange: icon(<path d="M4 10h13l-3-3M20 14H7l3 3" />),
};

// The clock-face ring around the middle button: twelve ticks, longer at the quarters (FotoLekti's shutter).
const TICKS = Array.from({ length: 12 }, (_, i) => i);

/**
 * The buttons under the figures: the banks' rates, speak, hear the answer,
 * clear — with "hear" as the large one.
 * The ref lands on the row so the recorder can drive `--level` on it directly,
 * twenty times a second, without re-rendering React.
 */
const VoiceDock = forwardRef(function VoiceDock(
  { phase, canSpeak, canHear, canClear, onExchange, onMic, onHear, onClear, t }, ref,
) {
  const listening = phase === 'listening', speaking = phase === 'speaking';
  return (
    <div className="dock" ref={ref} data-phase={phase}>
      <div className="dock-item">
        <button className="disc" type="button" onClick={onExchange} aria-label={t('exchange.button')}>
          {ICONS.exchange}
        </button>
        <span className="dock-caption" aria-hidden="true">{t('exchange.button')}</span>
      </div>

      <div className="dock-item">
        <button className="disc dock-mic" type="button" onClick={onMic} disabled={!canSpeak} aria-pressed={listening}
          aria-label={t(listening ? 'dock.done' : 'dock.speak')}>
          {listening ? ICONS.stop : ICONS.mic}
        </button>
        <span className="dock-caption" aria-hidden="true">{t(listening ? 'dock.done' : 'dock.speak')}</span>
      </div>

      <div className="dock-item">
        <button className="dock-main" type="button" onClick={onHear} disabled={!canHear && !speaking}
          aria-label={t(speaking ? 'dock.stop' : 'dock.hear')}>
          <svg className="dock-ticks" viewBox="0 0 100 100" aria-hidden="true">
            {TICKS.map((i) => (
              <line key={i} className={i % 3 ? 'tick-minor' : 'tick-major'}
                x1="50" x2="50" y1="2" y2={i % 3 ? 9 : 12} transform={`rotate(${i * 30} 50 50)`} />
            ))}
          </svg>
          <span className="dock-core">{speaking ? ICONS.stop : ICONS.hear}</span>
        </button>
        <span className="dock-caption" aria-hidden="true">{t(speaking ? 'dock.stop' : 'dock.hear')}</span>
      </div>

      <div className="dock-item">
        <button className="disc" type="button" onClick={onClear} disabled={!canClear} aria-label={t('dock.clear')}>
          {ICONS.clear}
        </button>
        <span className="dock-caption" aria-hidden="true">{t('dock.clear')}</span>
      </div>
    </div>
  );
});

export default VoiceDock;
